import ApiPermisos from "./../../services/apiPermisos";

export default {
  namespaced: true,
  state: {
    roles: [],
    selected: null,
    loading: false,
    loading2: false,
    lineDeals: [],
    lineDeal: {},
    lineDealInfo: {},
    supportBags: [],
    supportBag: [],
    scenarios: [],
    groupOfCharges: [],
    charges: [],
    charge: {},
    pointsSales: [],
    pointsSale: {},
    employees: [],
    employee: {},
    services: {},
    lists: [],
    banks: [],
    bank: {},
    zones: [],
    zone: {},
    error: {},
    message: {},
    history: {},
    typeOfList: {
      banks: 1,
    },
  },
  getters: {},
  mutations: {
    setSelect: (state, selected) => {
      state.selected = selected;
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    },
    setLoading2: (state, loading2) => {
      state.loading2 = loading2;
    },
    setLineDeals: (state, lineDeals) => {
      state.lineDeals = lineDeals;
    },
    setLineDeal: (state, lineDeal) => {
      state.lineDeal = lineDeal.data;
    },
    setLineDealInfo: (state, lineDealInfo) => {
      state.lineDealInfo = lineDealInfo;
    },
    setSupportBags: (state, supportBags) => {
      state.supportBags = supportBags;
    },
    setSupportBag: (state, supportBag) => {
      state.supportBag = supportBag.data;
    },
    setSupportBagInfo: (state, supportBag) => {
      state.supportBag = supportBag;
    },
    setError: (state, error) => {
      state.error.message = error;
    },
    setMessage: (state, message) => {
      state.error = {};
      state.message = message;
    },
    setScenarios: (state, scenarios) => {
      state.scenarios = scenarios;
    },

    setScenarioInfo: (state, scenarios) => {
      state.scenarios = scenarios;
    },

    setCharges: (state, charges) => {
      state.charges = charges;
    },

    setCharge: (state, charge) => {
      state.charge = charge.data;
    },

    setServices: (state, services) => {
      state.services = services;
    },

    setPointsSales: (state, pointsSales) => {
      state.pointsSales = pointsSales;
    },
    setPointSales: (state, pointsSale) => {
      state.pointsSale = pointsSale.data;
    },
    setGroupOfCharges: (state, groupOfCharges) => {
      state.groupOfCharges = groupOfCharges;
    },
    setBanks: (state, banks) => {
      state.banks = banks;
    },
    setBank: (state, bank) => {
      state.bank = bank.data;
    },
    setZones: (state, zones) => {
      state.zones = zones;
    },
    setZone: (state, zone) => {
      state.zone = zone.data;
    },
    setEmployees: (state, employees) => {
      state.employees = employees;
    },
    setEmployee: (state, employee) => {
      state.employee = employee.data;
    },
    setLists: (state, lists) => {
      state.lists = lists;
    },
    setRoles: (state, roles) => {
      state.roles = roles.data;
    },
    setModificationHistory: (state, history) => {
      state.history = history.data;
    },
  },
  actions: {
    // Guarda la selección

    actSelected({ commit }, selection) {
      commit("setSelect", selection);
    },

    // Guarda error

    actSetError({ commit }, error) {
      commit("setError", error);
    },

    // Guarda mensaje de exito

    actSetMessage({ commit }, message) {
      commit("setMessage", message);
    },

    //Trae la lista lineas de Negocio
    actLineDeals: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getLineDeals(data);
        commit("setLoading", false);
        commit("setLineDeals", response);
      } catch (error) {
        return error;
      }
    },

    //Trae la linea de Negocio
    actLineDeal: async ({ commit }, id) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getLineDeal(id);
      if (response.error) {
        return response.error;
      } else {
        console.log(response);
        commit("setLoading", false);
        commit("setLineDeal", response);
      }
      return true;
    },

    // Guarda una linea de negocio

    actSaveLineDeal: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.saveLineDeal(data);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setMessage", response);
          return response;
        }
      } catch (error) {
        commit("setError", error);
      }
    },

    // Actualiza una linea de negocio

    actUpdateLineDeal: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.uptLineDeal(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    // Elimina una linea de negocio

    actDeleteLineDeal: async ({ commit }, id) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.delLineDeal(id);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setMessage", response);
          return response;
        }
      } catch (error) {
        commit("setError", error);
      }
    },

    // Trae las bolsas de Apoyo

    actSupportBags: async ({ commit }, page) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getSupportBags(page);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setLoading", false);
        commit("setSupportBags", response);
      }
      return true;
    },

    actSupportBag: async ({ commit }, id) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getSupportBag(id);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setSupportBag", response);
      }
      return true;
    },

    // Guarda una bolsas de Apoyo

    actSaveSupportBag: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.saveSupportBag(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    // Actualiza una bolsa de Apoyo

    actUpdateSupportBag: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.uptSupportBag(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },
    // Elimina una bolsa de apoyo

    actDeleteSupportBag: async ({ commit }, id) => {
      commit("setLoading", true);
      let response = await ApiPermisos.delSupportBag(id);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    // Trae los Escenarios por Linea de Negocio

    actScenariosByLd: async ({ commit }, id) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getScenarioByLd(id);
        commit("setLoading", false);
        commit("setScenarios", response);
      } catch (error) {
        commit("setError", error);
        return error;
      }
    },

    // Trae los Cargos

    actCharges: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getCharges(data);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setLoading", false);
        commit("setCharges", response);
      }
      return true;
    },

    // Trae un cargo por ID

    actCharge: async ({ commit }, id) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getCharge(id);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setLoading", false);
        commit("setCharge", response);
      }
      return true;
    },

    // Trae los cargos de un escenario asociado a un punto de Venta

    actChargesByPointSales: async ({ commit }, id) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getChargesByPointSales(id);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          commit("setLoading", false);
          return response.error;
        } else {
          commit("setLoading", false);
          commit("setCharges", response);
        }
        return true;
      } catch (error) {
        commit("setLoading", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
        return error;
      }
    },

    // Trae las Categorias

    actServices: async ({ commit }, page) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getServices(page);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setLoading", false);
        commit("setServices", response);
      }
      return true;
    },

    // Guarda un Cargo

    actSaveCharge: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.saveCharge(data);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setMessage", response);
          return response;
        }
      } catch (error) {
        commit("setError", error);
        return error;
      }
    },

    // Actualiza un Cargo

    actUpdateCharge: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.uptCharge(data);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setMessage", response);
          return response;
        }
      } catch (error) {
        commit("setError", error.message);
      }
    },
    // Elimina un Cargo

    actDeleteCharge: async ({ commit }, id) => {
      commit("setLoading", true);
      let response = await ApiPermisos.delCharge(id);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    // Trae los Puntos de Venta

    actPointsSales: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getPointsSales(data);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setLoading", false);
        commit("setPointsSales", response);
      }
      return true;
    },

    // Trae los Punto de venta por ID

    actPointSales: async ({ commit }, id) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getPointSales(id);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setLoading", false);
        commit("setPointSales", response);
      }
      return true;
    },

    // Trae los Punto de venta por Zona

    actPointsSalesByZone: async ({ commit }, id) => {
      try {
        let empty = [];
        commit("setLoading", true);
        let response = await ApiPermisos.getPointsSalesByZone(id);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          commit("setPointsSales", empty);
          return response.error;
        } else {
          commit("setLoading", false);
          commit("setPointsSales", response);
        }
        return true;
      } catch (error) {
        commit("setError", error);
        return error;
      }
    },

    // Guarda un Punto de Venta

    actSavePointSale: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.savePointSale(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    // Actualiza un Punto de Venta

    actUpdatePointSale: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.uptPointSale(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },
    // Elimina un Punto de Venta

    actDeletePointSale: async ({ commit }, id) => {
      commit("setLoading", true);
      let response = await ApiPermisos.delPointSale(id);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    //Trae los Grupos de Cargos
    actGroupOfCharges: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getGroupOfCharges(data);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setLoading", false);
        commit("setGroupOfCharges", response);
      }
      return true;
    },

    // Guarda un Grupos de Cargos

    actSaveGroupOfCharges: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.saveGroupOfCharges(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    // Actualiza un Grupos de Cargos

    actUpdateGroupOfCharges: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.uptGroupOfCharges(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    // Elimina un Grupos de Cargos

    actDeleteGroupOfCharges: async ({ commit }, id) => {
      commit("setLoading", true);
      let response = await ApiPermisos.delGroupOfCharges(id);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    //Trae las categorias por ID de las opciones de los select general
    actSelectOptions: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getSelectById(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        if (data.type_list_id == 1) commit("setBanks", response);
      }
      return true;
    },
    // Guarda un banco

    actSaveBank: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.saveBank(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    //Trae los datos del Banco a editar
    actGetBank: async ({ commit }, id) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getBank(id);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setLoading", false);
        commit("setBank", response);
      }
      return true;
    },
    //Actualiza un banco

    actActBank: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.uptBank(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    // Elimina un banco

    actDelBank: async ({ commit }, id) => {
      commit("setLoading", true);
      let response = await ApiPermisos.delBank(id);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    //Trae las Zonas

    actGetZones: async ({ commit }, page) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getZones(page);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setLoading", false);
        commit("setZones", response);
      }
      return true;
    },

    //Trae las Zonas por lineas de Negocio

    actGetZonesByLB: async ({ commit }, id) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getZoneByLB(id);
        commit("setLoading", false);
        commit("setZones", response);
      } catch (error) {
        let empty = [];
        commit("setZones", empty);
        commit("setLoading", false);
        commit("setError", error.response.data.message);
        return error;
      }
    },

    // Guarda una Zona

    actSaveZone: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.saveZone(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    //Trae los datos de la zona a editar
    actGetZone: async ({ commit }, id) => {
      commit("setLoading", true);
      console.log("working");
      let response = await ApiPermisos.getZone(id);
      if (response.error) {
        commit("setError", response.error);
        commit("setLoading", false);
        return response.error;
      } else {
        commit("setLoading", false);
        commit("setZone", response);
      }
      return true;
    },
    //Actualiza una Zona

    actActZone: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.uptZone(data);
      commit("setLoading", false);
      if (response.error) {
        commit("setError", response.error);
        return response.error;
      } else {
        commit("setMessage", response);
        return response;
      }
    },

    // Elimina una Zona

    actDelZone: async ({ commit }, id) => {
      commit("setLoading", true);
      let response = await ApiPermisos.delZone(id);
      if (response.error) {
        commit("setError", response.error);
        commit("setLoading", false);
        return response.error;
      } else {
        commit("setMessage", response);
        commit("setLoading", false);
        return response;
      }
    },

    //Trae los emmpleados

    actGetEmployees: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getEmployees(data);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setEmployees", response);
        }
      } catch (error) {
        commit("setError", error);
      }
    },
    //Trae los deplegables ejm(tipos de contrato, tipos de documentos...etc) getCustomList

    actGetLists: async ({ commit }, page) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getLists(page);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setLists", response);
        }
      } catch (error) {
        commit("setError", error);
      }
    },

    //// Evalua si la linea de negocio tiene o no zonas, para asi mismo devolver Puntos de ventas o Zonas

    actGetCustomList: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getCustomList(data);
        commit("setLoading", false);
        let empty = [];
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else if (response.check_zones) {
          commit("setZones", response.zones);
          commit("setCharges", empty);
          commit("setPointsSales", empty);
        } else if (response.check_charges && response.check_points_sale) {
          commit("setZones", empty);
          commit("setCharges", response.charges);
          commit("setPointsSales", response.points_Sale);
        } else if (response.check_charges) {
          commit("setZones", empty);
          commit("setCharges", response.charges);
          commit("setPointsSales", empty);
        } else {
          console.log(response);
        }
      } catch (error) {
        commit("setError", error);
      }
    },

    // Guarda el empleado

    actSaveEmployee: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.saveEmployee(data);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setMessage", response);
          return response;
        }
      } catch (error) {
        commit("setLoading", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //Trae los emmpleados por ID

    actGetEmployee: async ({ commit }, id) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getEmployee(id);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setEmployee", response);
        }
      } catch (error) {
        commit("setLoading", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //Trae los emmpleados por ID getInfoLineDeal

    actActEmployee: async ({ commit }, id) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.uptEmployee(id);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setMessage", response);
        }
      } catch (error) {
        commit("setLoading", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //Elimina un empleado

    actDelEmployee: async ({ commit }, id) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.delEmployee(id);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setMessage", response);
        }
      } catch (error) {
        commit("setLoading", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //Trae los Roles de VP2

    actGetRoles: async ({ commit }) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getRolesVP2();
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setRoles", response);
        }
      } catch (error) {
        commit("setLoading", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //PUNTAJES************************************************
    //Trae la información completa de una Linea de Negocio

    actGetInfoLineDeal: async ({ commit }, id) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getInfoLineDeal(id);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setLineDealInfo", response);
        }
      } catch (error) {
        commit("setLoading", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //Trae la información completa de una Linea de Negocio

    actGetAllSupportBags: async ({ commit }) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getAllSupportBags();
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setSupportBags", response.data);
        }
      } catch (error) {
        commit("setLoading", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //Consulta si la bolsa de apoyo tiene puntaje diferenciado por Punto de venta, en la linea de Negocio

    actGetInfoBySupportBag: async ({ commit }, ids) => {
      try {
        commit("setLoading2", true);
        let response = await ApiPermisos.getInfoBySupportBag(ids);
        commit("setLoading2", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setSupportBagInfo", response);
        }
      } catch (error) {
        commit("setLoading2", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //Consulta los cargos asociados a la bolsa de apoyo

    actGetChargesBySupportBag: async ({ commit }, id) => {
      try {
        commit("setLoading2", true);
        let response = await ApiPermisos.getChargesBySupportBag(id);
        commit("setLoading2", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setSupportBagInfo", response);
        }
      } catch (error) {
        commit("setLoading2", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //Consulta los cargos asociados al escenario

    actGetInfoByScenario: async ({ commit }, id) => {
      try {
        commit("setLoading2", true);
        let response = await ApiPermisos.getInfoByScenario(id);
        commit("setLoading2", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setScenarioInfo", response);
        }
      } catch (error) {
        commit("setLoading2", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //Guarda los puntajes

    actSavePoints: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.savePoints(data);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setMessage", response);
          return response;
        }
      } catch (error) {
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //Trae el historial de puntajes

    actGetModificationHistory: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        let response = await ApiPermisos.getModificationHistory(data);
        commit("setLoading", false);
        if (response.error) {
          commit("setError", response.error.trace.message[0]);
          return response.error;
        } else {
          commit("setModificationHistory", response);
          return response;
        }
      } catch (error) {
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },

    //Consulta los cargos asociados al escenario

    actSaveFileEmployee: async ({ commit }, file) => {
      try {
        commit("setLoading2", true);
        await ApiPermisos.saveFileEmployee(file)
          .then((response) => {
            if (response.message === undefined) {
              /* get errors excel */
              let blob = new Blob([response], {
                type:
                  "application/ vnd.openxmlformats - officedocument.spreadsheetml.sheet ; charset = UTF-8 ",
              }); // set the file type for blob, taking. Xlsx as an example
              let url = window.URL.createObjectURL(blob); // create a temporary URL to point to the blob object
              let a = document.createElement("a");
              a.href = url;
              a.setAttribute("download", "errores-carga-masiva.csv");
              a.click();

              //Release the temporary object URL
              window.URL.revokeObjectURL(url);

              commit("setLoading2", false);
              commit(
                "setError",
                "Su archivo tiene errores, se verán reflejados en el anexo descargado."
              );
            } else {
              commit("setLoading2", false);
              commit("setMessage", response);
              return response;
            }
          })
          .catch((error) => {
            commit("setLoading2", false);
            let error2 = error.response;
            commit("setError", error2.data.message);
          });
      } catch (error) {
        commit("setLoading2", false);
        let error2 = error.response;
        commit("setError", error2.data.message);
      }
    },
  },
};
